import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Select, Button } from "antd";
import "./resumeFilterSidebarForm.scss";
import useRDBStore from "../../store/rdb";
import { EDUCATION_OPTIONS, RDB_FILTER_DURATION_OPTIONS, WORK_OPTIONS } from "../../helper/categoryconstants";
import { bgvStatusFilter, candidateStatusFilter, documentStatusFilter, interviewStatusFilter, offerStatusFilter, resumeStatusFilter } from "../../helper/filterconstants";
import useSettingstore from "../../store/settings.store";

function ResumeFilterSidebarFrom({pageResult, page, pageSize,pageHandler}) {
    const navigate = useNavigate();
    const [isDurationChanged, setDuration] = useState(false); 
    const {  addOrUpdateSetting } = useSettingstore();
    
    const {rdbPageResult, rdbResumeSearchPerPage } =
        useRDBStore();
        const getUploadingtime = (value) =>{
          const label = RDB_FILTER_DURATION_OPTIONS.find(item => item.value === value)?.label || value;   
          return label
        }         
    const encodeJson = (values) =>{

        let encodedJsonValues ={};

        //console.log("ResumeFilterSidebarFrom page result", pageResult)
        //now fill the parameters
        encodedJsonValues.skills=pageResult?.triggerreq.skills;
        encodedJsonValues.oskills=pageResult?.triggerreq.oskills;
        encodedJsonValues.noticeperiod= pageResult?.triggerreq?.noticeperiod !=''?parseInt(pageResult?.triggerreq.noticeperiod):90;
        encodedJsonValues.plocation=pageResult?.triggerreq.plocation;           
        encodedJsonValues.minexp= pageResult?.triggerreq.minexp;
        encodedJsonValues.maxexp= pageResult?.triggerreq.maxexp;
        encodedJsonValues.pagenum= 1; //starts with first page
        encodedJsonValues.maxresumespp= pageSize;
        if(isDurationChanged)
           encodedJsonValues.duration = values.duration
        else
           encodedJsonValues.duration = pageResult?.triggerreq.duration

        encodedJsonValues.filter ={};
        encodedJsonValues.filter.minctc = pageResult?.triggerreq.filter.minctc
        encodedJsonValues.filter.maxctc = pageResult?.triggerreq.filter.maxctc
        encodedJsonValues.filter.clocation =pageResult?.triggerreq.filter.clocation
        encodedJsonValues.filter.lwdstatus =pageResult?.triggerreq.filter.lwdstatus
        encodedJsonValues.filter.workmode = values.workmode
        encodedJsonValues.filter.education= values.education

        encodedJsonValues.filter.candidatestatus = values.candidatestatus
        encodedJsonValues.filter.resumestatus = values.resumestatus
        encodedJsonValues.filter.interviewstatus = values.interviewstatus
        encodedJsonValues.filter.bgvstatus = values.bgvstatus
        encodedJsonValues.filter.offerstatus = values.offerstatus
        encodedJsonValues.filter.documentstatus = values.documentstatus
        
        //console.log("ResumeFilterSidebarFrom encode json", encodedJsonValues)
        return encodedJsonValues
    }
    
  const handleFormSubmitRDB = (values) => {
     const jasonValues = encodeJson(values); 
     //just store... no need toc all the endoint again.
     addOrUpdateSetting({key: "resumeDB",value: JSON.stringify(jasonValues),});     
     rdbResumeSearchPerPage(jasonValues,jasonValues.duration);   
     if(pageHandler) pageHandler(1);   
  };
  
  const handleDuration = (value) => {
      setDuration(value)      
  };

    var triggerReqValues = {}
    if (pageResult) {
        triggerReqValues = {
            candidateStatus: pageResult?.triggerreq.filter.candidatestatus,
            resumeStatus: pageResult?.triggerreq.filter.resumestatus,
            interviewStatus: pageResult?.triggerreq.filter.interviewstatus,
            bgvStatus: pageResult?.triggerreq.filter.bgvstatus,
            documentStatus: pageResult?.triggerreq.filter.documentstatus,
            offerStatus: pageResult?.triggerreq.filter.offerstatus,
            duration: pageResult?.triggerreq.filter.duration,
      };
    }
      
  return (
    <div className="resume-filter-sidebar-wrapper">
        <Form
          className="jd-creation-form"
          name="rdb-filter-form"
          justify="start"
          layout="vertical"
          autoComplete="off"
          onFinish={handleFormSubmitRDB}
        >

        <Form.Item
          className="jd-creation-field-item"
          label="Candidate Status"
          name="candidatestatus"
        >
          <Select
            className="jd-creation-input"                          
            placeholder={triggerReqValues?.candidateStatus}
            mode="multiple"
            showSearch={true}
            maxTagCount="responsive"
            filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
            options={candidateStatusFilter}            
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Resume Status"
          name="resumestatus"
        >          
          <Select
            className="jd-creation-input" 
            placeholder={triggerReqValues?.resumeStatus}
            mode="multiple"
            showSearch={true}
            maxTagCount="responsive"
            filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
            options={resumeStatusFilter}  
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Interview Status"
          name="interviewstatus"
        >
          <Select
            className="jd-creation-input" 
            placeholder={triggerReqValues?.interviewStatus}
            mode="multiple"
            showSearch={true}
            maxTagCount="responsive"
            filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
            options={interviewStatusFilter}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="BGV Status"
          name="bgvstatus"
        >
          <Select
            className="jd-creation-input" 
            placeholder="Please select"
            mode="multiple"
            showSearch={true}
            maxTagCount="responsive"
            filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }            
            options={bgvStatusFilter}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Selection Status"
          name="offerstatus"
        >         
          <Select
            className="jd-creation-input" 
            placeholder="Please select"
            mode="multiple"
            showSearch={true}
            maxTagCount="responsive"
            filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
            options={offerStatusFilter}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Document Status"
          name="documentstatus"
        >
          <Select
            className="jd-creation-input" 
            placeholder="Please select"
            mode="multiple"
            showSearch={true}
            maxTagCount="responsive"
            filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
            options={documentStatusFilter}
          />                         
        </Form.Item>    
        <Form.Item
          className="jd-creation-field-item"
          label="Work Mode"
          name="workmode"
        >
          <Select
            className="jd-creation-input" 
            mode="multiple"
            allowClear                           
            placeholder="Please select"
            options={WORK_OPTIONS}
          />                         
        </Form.Item>
        <Form.Item
          className="jd-creation-field-item"
          label="Education"
          name="education"
        >
          <Select
            className="jd-creation-input" 
            mode="multiple"
            allowClear                           
            placeholder="Please select"
            options={EDUCATION_OPTIONS}
          />                         
        </Form.Item>                                                            
        <Form.Item
            name="duration"
            className="jd-creation-field-item"
            label="Uploading Period"
        >
            <Select
                className="jd-creation-input"                           

                onClick={handleDuration}
                placeholder = {getUploadingtime(pageResult?.triggerreq.duration)}
                options={RDB_FILTER_DURATION_OPTIONS}
              /> 
          </Form.Item>  
          <Button
              style={{ width: "60%", height: "40px", fontWeight: "600" }}
              type="primary"
              htmlType="submit"
          >
              Update Filter
          </Button>
        </Form>
    </div>
  );
}

export default ResumeFilterSidebarFrom;
